module.exports = __webpack_public_path__ + "static/media/yellow-bulb-image.eb2f27fc.png";